var map = {
	"./email-monochrome.svg": "0617",
	"./facebook-monochrome.svg": "1b48",
	"./instagram-monochrome.svg": "46e3",
	"./linkedin-monochrome.svg": "0d84",
	"./messenger-monochrome.svg": "8197",
	"./telegram-monochrome.svg": "2aa4",
	"./tiktok-monochrome.svg": "d9f7",
	"./twitter-monochrome.svg": "1e31",
	"./whatsapp-monochrome.svg": "23ce",
	"./youtube-monochrome.svg": "90ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7fc6";